import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import '../../components/AdminTables.css';
import { getToken } from '../../utils/auth';

function CommitteesAdmin() {
  const [committees, setCommittees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCommittees = async () => {
      setLoading(true);
      try {
        const token = getToken();
        const res = await fetch('/api/admin/committees', { headers: { 'x-auth-token': token } });
        if (!res.ok) throw new Error('Failed');
        const data = await res.json();
        setCommittees(data);
      } catch (err) {
        console.error(err);
      } finally { setLoading(false); }
    };
    fetchCommittees();
  }, []);

  const handleDelete = async (acctNum) => {
    if (!window.confirm('Delete committee ' + acctNum + '?')) return;
    try {
      const token = getToken();
      const res = await fetch('/api/admin/committees/' + acctNum, { method: 'DELETE', headers: { 'x-auth-token': token } });
      if (!res.ok) throw new Error('Delete failed');
      setCommittees(committees.filter(c => c.AcctNum !== acctNum));
    } catch (err) { alert('Error: ' + err.message); }
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
  <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto', boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12, background: '#fff' }}>
          <h2 style={{ marginTop: 0 }}>Manage Committees</h2>
          
          {loading && <div>Loading...</div>}
          <table className="admin-table">
            <thead>
              <tr>
                <th>AcctNum</th>
                <th>Name</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {committees.map(c => (
                <tr key={c._id}>
                  <td>{c.AcctNum}</td>
                  <td>{c.Name}</td>
                  <td>{c.Type}</td>
                  <td>
                    <div className="admin-actions">
                      <button className="btn btn-edit" onClick={() => window.location = '/admin/committees/edit/' + c.AcctNum}>Edit</button>
                      <button className="btn btn-delete" onClick={() => handleDelete(c.AcctNum)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </div>
    </div>
  );
}

export default CommitteesAdmin;
